<script>
  import { useOutsideClick } from '@/helpers';

  export default {
    mounted () {
      useOutsideClick(this, 'nav', () => this.$emit('close'));
    },
  };
</script>

<template>
  <nav class="header-dropdown" ref="nav">
    <ul class="header-dropdown__list">
      <span class="header-dropdown__triangle"></span>

      <li class="header-dropdown__item">
        <RouterLink
          to="/conta/dados-da-conta"
          class="header-dropdown__link"
          >
          Perfil
        </RouterLink>
      </li>

      <li class="header-dropdown__item">
        <a
          href="#"
          class="header-dropdown__link"
          >
          Sair do CoinBRAX
        </a>
      </li>
    </ul>
  </nav>
</template>

<style lang="scss">
  .header-dropdown {
    top: 0;
    right: 8px;
    z-index: 2;
    transition: 150ms;
    padding-top: 52px;
    position: absolute;

    &__list {
      width: 187px;
      font-size: 14px;
      border-radius: 4px;
      position: relative;
      background-color: #26273f;
      box-shadow: 0 2px 5px 0 rgba(#000, .15);
    }

    &__triangle {
      width: 0;
      height: 0;
      top: -11px;
      right: 16px;
      position: absolute;
      border-style: solid;
      border-width: 0 9.5px 10.5px 9.5px;
      border-color: transparent transparent #26273f transparent;
    }

    &__link {
      opacity: .5;
      padding: 16px;
      display: block;
      color: #b2b8c5;
      transition: 150ms;

      &:hover {
        opacity: 1;
      }
    }
  }
</style>
